export const settings = {
  storageKey: "alzata-auth",
  //baseUrl: "https://localhost:5001",
  //baseUrl: "https://dofbadminapi.azurewebsites.net",
  // baseUrl: "https://dfobveteranappapi.azurewebsites.net",
  // baseUrl: "https://localhost:44353",
  // baseUrl: "https://dfobadminapitest-a0faf5dabghuhygd.canadacentral-01.azurewebsites.net",
  // baseUrl: "https://app.test.dfob.org",
  baseUrl: "https://app.dfob.org",
  logLevel: 5,
  testValue: process.env.VUE_APP_TEST_VALUE,
};

interface IApiOptions {
  authRequired?: boolean;
  inAuthRetry?: boolean;
  emitEventOnFailure?: boolean;
  body?: any;
  query?: any;
}

interface IAuthInfo {
  tokenType: string;
  accessToken: string;
  refreshToken: string;
}

export function getAuthInfo(): IAuthInfo | undefined {
  try {
    const stringValue = localStorage.getItem(settings.storageKey);
    if (!stringValue) {
      throw "Invalid stored values!";
    }
    const authInfo = JSON.parse(stringValue) as IAuthInfo;
    if (
      !authInfo.tokenType ||
      !authInfo.accessToken ||
      !authInfo.refreshToken
    ) {
      throw "Invalid stored values!";
    }
    return {
      tokenType: authInfo.tokenType,
      accessToken: authInfo.accessToken,
      refreshToken: authInfo.refreshToken,
    };
  } catch {
    localStorage.removeItem(settings.storageKey);
    return undefined;
  }
}

export function setAuthInfo(info: IAuthInfo) {
  try {
    const stringValue = JSON.stringify(info);
    localStorage.setItem(settings.storageKey, stringValue);
  } catch {
    // Do nothing
  }
}

export function clearAuthInfo() {
  try {
    localStorage.removeItem(settings.storageKey);
  } catch {
    // Do nothing
  }
}

function log(level: number, ...params: any[]) {
  if (level <= settings.logLevel) {
    console.log(...params);
  }
}

function makeUrl(url: string): string {
  const madeUrl = settings.baseUrl + url; //.replace(/^\/*/, "/");

  return madeUrl;
}

async function doFetch(
  request: Request,
  options: IApiOptions
): Promise<Response> {
  log(10, `>>> ${request.method} ${request.url}`);
  const authInfo = getAuthInfo();
  if (authInfo) {
    request.headers.delete("Authorization");
    request.headers.append(
      "Authorization",
      `${authInfo.tokenType} ${authInfo.accessToken}`
    );
  }
  const res = await fetch(request);
  log(10, `<<< ${request.method} ${request.url} ${res.status}`);
  if (options?.authRequired && !res.ok && !options?.inAuthRetry) {
    // TODO: handle refresh token authentication
  }
  return res;
}

export function doGet(url: string, options: IApiOptions) {
  if (options?.query) {
    const searchParams = new URLSearchParams();
    for (const k in options.query) {
      searchParams.append(k, options.query[k]);
    }
    url = url + "?" + searchParams.toString();
  }
  const req = new Request(makeUrl(url));
  return doFetch(req, options);
}

function doVerb(method: string, url: string, options: IApiOptions) {
  const request = new Request(makeUrl(url), {
    method,
    cache: "no-cache",
    headers: {
      "Content-Type": "application/json",
    },
    body: options.body ? JSON.stringify(options.body) : null,
  });
  return doFetch(request, options);
}

export function doPost(url: string, options: IApiOptions) {
  return doVerb("POST", url, options);
}

export function doPut(url: string, options: IApiOptions) {
  return doVerb("PUT", url, options);
}

export function doDelete(url: string, options: IApiOptions) {
  return doVerb("DELETE", url, options);
}

async function processJson(req: Promise<Response>) {
  const res = await req;
  const text = await res.text();
  log(10, `<<< ${text}`);
  return JSON.parse(text);
}

export function getJson(url: string, options: IApiOptions) {
  return processJson(doGet(url, options));
}

export function postJson(url: string, options: IApiOptions) {
  return processJson(doPost(url, options));
}

export function putJson(url: string, options: IApiOptions) {
  return processJson(doPut(url, options));
}

export function deleteJson(url: string, options: IApiOptions) {
  return processJson(doDelete(url, options));
}
